import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable react/no-array-index-key */
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Rating.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Rating = function Rating(_ref) {
  var char = _ref.char,
      className = _ref.className,
      count = _ref.count,
      light = _ref.light,
      size = _ref.size,
      value = _ref.value;
  // const starWidthPercentage = 100 / count;
  var starMarginRight = 6;
  var integer = Math.floor(value);
  var float = value % 1;
  var width = "".concat(size * integer + size * float + integer * starMarginRight, "px");
  var fixedValue = value.toFixed(1).replace('.0', '');
  return /*#__PURE__*/_jsxs("div", {
    "aria-label": "Star Rating ".concat(fixedValue, " of ").concat(count, "."),
    className: cc([css.root, className]),
    role: "img",
    style: {
      fontSize: "".concat(size, "px"),
      height: "".concat(size, "px")
    },
    title: "Rated ".concat(fixedValue, " of ").concat(count),
    children: [/*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      className: css.stars,
      children: Array.from(Array(count)).map(function (_, idx) {
        return /*#__PURE__*/_jsx("span", {
          className: css.star,
          children: char
        }, "bg-star-".concat(idx));
      })
    }), /*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      className: cc([css.stars, css.rate]),
      style: {
        width: width
      },
      children: Array.from(Array(count)).map(function (_, idx) {
        return /*#__PURE__*/_jsx("span", {
          className: cc([css.star, css.rate, _defineProperty({}, css.light, light)]),
          children: char
        }, "star-".concat(idx));
      })
    })]
  });
};

Rating.defaultProps = {
  char: '★',
  className: '',
  count: 5,
  light: false,
  size: 18,
  value: 0
};
Rating.propTypes = {
  char: PropTypes.string,
  className: PropTypes.string,
  count: PropTypes.number,
  light: PropTypes.bool,
  size: PropTypes.number,
  value: PropTypes.number
};
export default Rating;